import { Component } from "@angular/core";

/**
 * Presentational fragment for the shared calendar / modify / call action block
 * that appears identically inside several patient-notification email cards.
 *
 * Uses an attribute selector on a <table> so the host element IS the table that
 * the original markup used (no extra DOM node is introduced and the rendered
 * output stays byte-equivalent). The aria-* attributes remain on the host table
 * at the usage site; this template supplies the table body only.
 */
@Component({
  selector: "table[appNotificationActions]",
  templateUrl: "./notification-footer.component.html",
})
export class NotificationFooterComponent {}
